import React from 'react';

function RenderSoapCounsellingData({ data, id }) {
  return (
    <div className="smart-tag-sec content-line-break">
      <div className="smart-tag-bdy" id={'sectionVal_' + id}>
        <span
          className="frst-sec-val sec-colr smart-tag-bdy-rw"
          dangerouslySetInnerHTML={{ __html: data?.soapStr }}
        />
      </div>
    </div>
  );
}

export default RenderSoapCounsellingData;
